var exports = {
  "z": "x1cb7f6e3--9623f5--root",
  "D": "x1cb7f6e3--9623f5--title",
};

module.exports = exports;
